<script setup lang="ts">
import type { PropType } from 'vue'

defineProps({
  isActive: {
    type: Boolean,
    required: true,
  },
  onClick: {
    type: Function as PropType<() => void>,
    required: true,
  },
})
</script>

<template>
  <div class="flex cursor-pointer items-center" @click.prevent.stop="onClick">
    <div class="relative">
      <input type="checkbox" class="sr-only" :checked="isActive" />
      <div
        class="toggle-bar shadow-inner h-[0.875rem] w-8 rounded-full bg-s-400 transition"
      />
      <div
        class="dot shadow absolute -top-[3px] h-5 w-5 rounded-full bg-s-500 transition"
      />
    </div>
  </div>
</template>

<style scoped>
input:checked ~ .dot {
  transform: translateX(60%);

  @apply bg-p-500;
}

input:checked ~ .toggle-bar {
  @apply bg-p-200;
}
</style>
